'use client'

import { Button, Dialog, Text } from '@vinted/web-ui'

import { useTranslate } from '@marketplace-web/shared/i18n'

import { FaqEntryType } from 'constants/faq-entry'
import FaqEntryUrl from 'components/FaqEntryUrl'

type Props = {
  onEditClick: () => void
  onSendClick: () => void
  onLearnMoreClick: () => void
}

const EmailSharingModal = ({ onEditClick, onSendClick, onLearnMoreClick }: Props) => {
  const translate = useTranslate('conversation.email_sharing_modal')

  const getLearnMoreLink = () => (
    <FaqEntryUrl
      key="learn-more-link"
      type={FaqEntryType.SpamPhishing}
      render={url => (
        <a href={url} target="_blank" rel="noreferrer" onClick={onLearnMoreClick}>
          {translate('learn_more_link')}
        </a>
      )}
    />
  )

  return (
    <Dialog
      testId="email-sharing-modal"
      title={translate('title')}
      body={
        <Text as="span" text={translate('body', { learn_more_link: getLearnMoreLink() })} html />
      }
      actions={[
        {
          text: translate('actions.edit'),
          callback: onEditClick,
          style: Button.Styling.Filled,
          testId: 'email-sharing-modal--edit-button',
        },
        {
          text: translate('actions.send'),
          callback: onSendClick,
          testId: 'email-sharing-modal--send-button',
        },
      ]}
      show
    />
  )
}

export default EmailSharingModal
